<template>
    <div class="container">
      <section>
        <img src="@/assets/images/su@2x.png" alt="">
        <h3>恭喜您已预约成功</h3>
        <p>预约码为: {{code}}</p>
        <div @click="toApplyDetail">确定</div>
      </section>
    </div>
</template>

<script>
    export default {
      data(){
        return {
          code:''
        }
      },
      methods:{
        toApplyDetail(){
          this.wx.closeWindow();
        }
      },
      created(){
        this.code = this.$route.query.code
      },
    }
</script>

<style scoped lang="scss">
  .container{
    @include background();
    background:$bgfff;
    section{
      padding-top:65px;
      img{
        width:80px;
        height:80px;
        margin:0 auto 10px auto;
      }
      h3{
        @include text_font('PingFangSC',16px,normal,#333,center);
      }
      p{
        margin:20px auto 0 auto;
        line-height: 20px;
        @include text_font('PingFangSC',14px,normal,#666,center);
      }
      div{
        width:345px;
        height:45px;
        line-height:45px;
        margin:30px auto 0 auto;
        background:#41B7A7;
        border-radius:24px;
        @include text_font('PingFangSC',16px,normal,#fff,center);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/doorHelp/applySuccess.vue